import {CollapsibleNavList} from '@github-ui/layout-primitives/CollapsibleNavList'
import {StackIcon} from '@primer/octicons-react'

import {useIsRepoStacksPage} from './use-is-repo-stacks-page'

/** The Stacks item in the pulls dashboard's Pages group. The server only sends its URL when the viewer can see stacks. */
export function StacksNavItem({url}: {url: string}) {
  const isCurrent = useIsRepoStacksPage()

  return (
    <CollapsibleNavList.LinkItem
      to={url}
      icon={StackIcon}
      label="Stacks"
      aria-current={isCurrent ? 'page' : undefined}
    />
  )
}
